/* unplugin-vue-components disabled */import { render } from "./publishCourse.vue?vue&type=template&id=df830672&scoped=true"
import script from "./publishCourse.vue?vue&type=script&lang=js"
export * from "./publishCourse.vue?vue&type=script&lang=js"

import "./publishCourse.vue?vue&type=style&index=0&id=df830672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df830672"]])

export default __exports__